import VenueActions, {VenueActionNames} from 'app/actions/venue.actions';
import TrackingService from 'app/services/tracking/tracking.service';

/**
 * Purpose of these "Actions" is to mimic a more redux-style of event management, which
 * should make transitioning to redux a little easier when the time comes.
 */

const NS = 'LoginActions';

export enum LoginActionNames {
  APP_OPENED = 'APP_OPENED',
  LOGOUT = 'logout',
  TRIGGER_LOGOUT = 'trigger-logout',
}

class LoginActions {
  private $rootScope: any;
  private $state: any;
  private $stateParams: any;
  private $localStorage: any;
  private readyCB: () => void;

  public setup($rootScope: any, $state: any, $stateParams: any, $localStorage: any): void {
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$localStorage = $localStorage;
    if (this.readyCB) {
      this.readyCB();
    }
  }

  registerForReadyCB(cb: () => void) {
    if (this.$rootScope) {
      cb();
    } else {
      this.readyCB = cb;
    }
  }

  public handleLogout = (callback: () => void): any => {
    return this.$rootScope.$on(LoginActionNames.LOGOUT, () => {
      callback();
    });
  }
  public handleTriggerLogout = (callback: () => void): any => {
    return this.$rootScope.$on(LoginActionNames.TRIGGER_LOGOUT, () => {
      callback();
    });
  }
  public onTriggerLogout = (): void => {
    this.$rootScope.$broadcast(LoginActionNames.TRIGGER_LOGOUT, null);
  }

  public handleAppOpened = (callback: () => void): any => {
    return this.$rootScope.$on(LoginActionNames.APP_OPENED, () => {
      callback();
    });
  }

  public openApp() {
    // go to the request view
    let completeState = 'bookings';
    if (this.$stateParams.completeState) {
      completeState = this.$stateParams.completeState;
    }
    // remove all parameters from the URL, pushState or replaceState will not work
    const currentUrl = window.location.href;
    window.location.href = currentUrl.split('?')[0] + '#/' + completeState;

    this.appOpened();
    this.$state.transitionTo(completeState);
  }

  public appOpened = (): void => {
    this.$rootScope.$broadcast(LoginActionNames.APP_OPENED, null);
  }

  public logout = (): void => {
    this.$rootScope.$broadcast(LoginActionNames.LOGOUT, null);
  }

  public switchVenue = (): void =>{
    this.$state.go('setup');
    this.$localStorage.couchUsers = null;
    VenueActions.venueAction(VenueActionNames.VENUE_CHANGE);
    TrackingService.trackEvent('Venue Change');
  }
}

const instance = new LoginActions();
export default instance as LoginActions;
